<template>
    <div class="user">
        <div class="search-box" :class="list.length !== 0 ? 'search-no-padding' : ''">
            <van-search v-model="searchData.keyword" placeholder="输入用户昵称/用户编号/手机号查询
" show-action :clearable="false" @search="search">
                <template #action>
                    <div @click="search" class="search-button">查询</div>
                </template>
            </van-search>
        </div>
        <div class="content" v-if="userTabActive == 1 && list.length > 0" v-watermark>
            <!-- <div class="header">
                <van-cell
                    clickable
                    :title="`全部（100）`"
                    @click="toggleAll"
                >
                <template #right-icon>
                    <van-checkbox v-model="checkAll" shape="square" />
                </template>
                </van-cell>
            </div> -->
            <van-checkbox-group v-model="userNos" ref="checkboxGroup" @change="handleChecked">
                <van-cell v-for="(item, index) in list" clickable :key="item.id" @click="toggle(index)"
                    class="title-box">
                   
                        <div class="title">
                            <img :src="item.photo ? item.photo : 'https://hospital-runsheng.oss-cn-shenzhen.aliyuncs.com/runsheng-wx/avatar.png'" alt="">
                            <div class="title_user_name"> 
                                <span>{{ item.nickName }}</span>
                                <span>注册时间：{{ item.createTime }}</span>
                            </div>
                            
                        </div>
                        <div>用户编号：{{ item.userNo}}<span class="copyClass" style="color: rgb(25, 137, 250)" @click="copy(item.userNo)"> 复制</span></div>
                        <div v-if="item.mobile">手机号：{{ item.mobile}} <span class="copyClass" @click="copy(item.mobile)"> 复制</span></div>
                        <div>归属工作室：{{ item.studioName}}</div>
                        <!-- <div class="mobile-box">{{ item.mobile || '' }}</div> -->
                   
<!--                    <template #right-icon>-->
<!--                        <van-checkbox :name="item.userNo" shape="square" ref="checkbox" />-->
<!--                    </template>-->
                </van-cell>
            </van-checkbox-group>
            <pagination :total="total" :pageSize="searchData.pageSize" :pageNo="pageNo" @pageChange="pageChange">
            </pagination>
        </div>
        <van-empty description="暂无数据" v-if="userTabActive == 1 && list.length < 1" />
        <div class="content" v-if="userTabActive == 2" v-watermark>
            <div class="bind_header">
                <div class="bind_user_name">
                    <van-checkbox v-model="bindAllChecked" shape="square" @click="bindAllCheckedChange">用户（{{
                        total
                    }}）</van-checkbox>
                </div>
                <div class="bind_doctor_name">
                    <van-popover v-model="showPopoverBindDoctor" trigger="click" :actions="actionsBindDoctor"
                        @select="onSelectBindDoctor">
                        <template #reference>
                            <span>{{ bindDoctorName }}</span>
                        </template>
                    </van-popover>
                    <van-icon name="arrow-down" />
                </div>
                <div class="bind_status">
                    <van-popover v-model="showPopoverBindStatus" trigger="click" :actions="actionsBindStatus"
                        @select="onSelectBindStatus" placement="bottom-end">
                        <template #reference>
                            <span>{{ bindStatusName }}</span>
                        </template>
                    </van-popover>
                    <van-icon name="arrow-down" />
                </div>
            </div>
            <div class="isOnline" v-if="bindDoctorData.doctorStatus === 0">
                <van-radio-group v-model="bindDoctorData.isOnline" direction="horizontal" @change="isOnlineChange">
                    <van-radio :name="''" shape="square">全部</van-radio>
                    <van-radio :name="1" shape="square">在线</van-radio>
                    <van-radio :name="0" shape="square">下线</van-radio>
                </van-radio-group>
            </div>
            <div class="bind_list" v-if="bindList.length > 0">
                <van-checkbox-group v-model="resultBind" ref="checkboxGroupBind" @change="bindUpdateChange">
                    <div class="bind_item" v-for="(item, index) in bindList" :key="index">
                        <div class="bind_user_name">
                            <van-checkbox :name="item.userNo" shape="square">
                                <div class="avatar">
                                    <img :src="item.photo" alt="">
                                    <span>{{ item.nickName }}</span>
                                </div>
                            </van-checkbox>
                        </div>
                        <div class="bind_doctor_name">{{ item.doctorNoName }}</div>
                        <div class="bind_status"
                            :class="{ 'doctorStatus1': item.doctorStatus === 1, 'isOnline0': item.doctorStatus === 0 && item.isOnline === 0 }">
                            {{ item.doctorStatusName }}</div>
                    </div>
                </van-checkbox-group>
            </div>
            <van-empty description="暂无数据" v-else />
            <pagination :total="total" :pageSize="searchData.pageSize" :pageNo="pageNo" @pageChange="pageChange"
                v-if="bindList.length > 0"></pagination>
        </div>
        <div class="content" v-if="userTabActive == 3 && list.length > 0" v-watermark>
            <div class="header">
                <van-cell clickable :title="`全部（${total}）`" @click="toggleAll">
                    <template #right-icon>
                        <van-checkbox v-model="checkAll" shape="square" />
                    </template>
                </van-cell>
            </div>
            <van-checkbox-group v-model="userNos" ref="checkboxGroup" @change="handleChecked">
                <van-cell v-for="(item, index) in list" clickable :key="item.id" @click="toggle(index)">
                    <template #title>
                        <div class="title">
                            <img :src="item.photo" alt="">
                            <span>{{ item.nickName }}</span>
                        </div>
                    </template>
                    <template #right-icon>
                        <van-checkbox :name="item.userNo" shape="square" ref="checkbox" />
                    </template>
                </van-cell>
            </van-checkbox-group>
            <pagination :total="total" :pageSize="searchData.pageSize" :pageNo="pageNo" @pageChange="pageChange">
            </pagination>
        </div>
        <van-empty description="暂无数据" v-if="userTabActive == 3 && list.length < 1" />
<!--        <div class="footer" v-if="userTabActive == 1 && list.length > 0">-->
<!--            <van-button type="info" :disabled="userNos.length < 1" block @click="transfer">转移用户</van-button>-->
<!--        </div>-->
        <div class="footer" v-if="userTabActive == 2 && bindList.length > 0">
            <van-button type="info" :disabled="resultBind.length < 1" block
                @click="bindDoctorUpdate">更换/解绑医生</van-button>
        </div>
        <div class="footer" v-if="userTabActive == 3 && list.length > 0">
            <van-button type="info" :disabled="userNos.length < 1" block @click="bindDoctor">绑定医生</van-button>
        </div>
    </div>
</template>
<script>
import { wxUserInfo, getEnterpriseWechatUserlist, getDoctorDropDownBox } from '../../../api/home.js'
export default {
    props: ['userTabActive'],
    watch: {
        userTabActive(value) {
            this.searchData.keyword = ''
            this.searchData.source = ''
            this.bindDoctorData.keyword = ''
            this.bindDoctorData.source = ''
            if (value == 1) {
                this.pageNo = 1
                this.searchData.pageNo = 1
                this.searchData.bindOrNot = ''
                this.userNos = []
                this.wxUserInfo()
            } else if (value == 2) {
                this.pageNo = 1
                this.bindDoctorData.pageNo = 1
                this.resultBind = []
                this.bindAllChecked = false;
                this.getDoctorDropDownBox()
                this.getEnterpriseWechatUserlist()
            } else if (value == 3) {
                this.pageNo = 1
                this.searchData.pageNo = 1
                this.searchData.bindOrNot = 1
                this.userNos = []
                this.wxUserInfo()
            }
        },
    },
    data() {
        return {
            checkAll: false,
            list: [],
            userNos: [],
            searchData: {
                pageNo: 1,
                pageSize: 10,
                bindOrNot: ''
            },
            pageNo: 1,
            total: 0,
            bindAllChecked: false,
            bindDoctorData: {
                pageNo: 1,
                pageSize: 10,
                doctorNo: '',
                doctorStatus: '',
                isOnline: ''
            },
            showPopoverBindDoctor: false,
            actionsBindDoctor: [],
            bindDoctorName: '全部医生',
            showPopoverBindStatus: false,
            actionsBindStatus: [
                { value: '', text: '全部状态' }, { value: 0, text: '启用' }, { value: 1, text: '禁用' }
            ],
            bindStatusName: '全部状态',
            resultBind: [],
            bindList: []
        }
    },
    created() {
        if (this.userTabActive == 1) {
            this.searchData.bindOrNot = ''
            this.wxUserInfo()
        } else if (this.userTabActive == 2) {
            this.getDoctorDropDownBox()
            this.getEnterpriseWechatUserlist()
        } else if (this.userTabActive == 3) {
            this.searchData.bindOrNot = 1
            this.wxUserInfo()
        }
    },
    activated() {
        if (this.userTabActive == 1) {
            this.userNos = []
            this.searchData.bindOrNot = ''
            this.wxUserInfo()
        } else if (this.userTabActive == 2) {
            this.getDoctorDropDownBox()
            this.resultBind = []
            this.getEnterpriseWechatUserlist()
        } else if (this.userTabActive == 3) {
            this.userNos = []
            this.searchData.bindOrNot = 1
            this.wxUserInfo()
        }
    },
    methods: {
        // 全部微信用户
        wxUserInfo() {
            wxUserInfo(this.searchData).then(res => {
                if (res.code == 0) {
                    this.list = res.data.list
                    this.total = res.data.total
                }
            })
        },
        search() {
            if (this.userTabActive === 2) {
                this.bindDoctorData.pageNo = 1
                this.bindDoctorData.source = 1
                this.bindDoctorData.keyword = (this.searchData.keyword || '').trim()
                this.getEnterpriseWechatUserlist()
            } else {
                this.searchData.pageNo = 1
                this.searchData.source = 1
                this.searchData.keyword = (this.searchData.keyword || '').trim()
                this.wxUserInfo()
            }
        },
        toggleAll() {
            this.checkAll = !this.checkAll
            this.$refs.checkboxGroup.toggleAll(this.checkAll);
        },
        toggle(index) {
            this.$refs.checkbox[index].toggle()
        },
        handleChecked() {
            this.checkAll = this.userNos.length == this.list.length
        },
        pageChange(pageNo) {
            this.searchData.pageNo = pageNo;
            this.wxUserInfo();
        },
        transfer() {
            sessionStorage.setItem('userNos', JSON.stringify(this.userNos))
            this.$router.push('/assistant')
        },
        getDoctorDropDownBox() {
            this.actionsBindDoctor = [{ value: '', text: '全部医生' }]
            getDoctorDropDownBox().then(res => {
                if (res.code == 0) {
                    this.actionsBindDoctor = this.actionsBindDoctor.concat(res.data)
                }
            })
        },
        bindAllCheckedChange() {
            this.$refs.checkboxGroupBind && this.$refs.checkboxGroupBind.toggleAll(this.bindAllChecked);
        },
        bindUpdateChange(value) {
            this.bindAllChecked = value.length === this.bindList.length
        },
        onSelectBindDoctor(action) {
            this.bindDoctorName = action.text
            this.bindDoctorData.doctorNo = action.value
            this.bindDoctorData.pageNo = 1
            this.pageNo = 1
            this.getEnterpriseWechatUserlist()
        },
        onSelectBindStatus(action) {
            this.bindStatusName = action.text
            this.bindDoctorData.doctorStatus = action.value
            this.bindDoctorData.isOnline = ''
            this.bindDoctorData.pageNo = 1
            this.pageNo = 1
            this.getEnterpriseWechatUserlist()
        },
        isOnlineChange(value) {
            this.bindDoctorData.pageNo = 1
            this.pageNo = 1
            this.getEnterpriseWechatUserlist()
        },
        getEnterpriseWechatUserlist() {
            getEnterpriseWechatUserlist(this.bindDoctorData).then(res => {
                if (res.code == 0) {
                    this.bindList = res.data.list
                    this.total = res.data.total
                }
            })
        },
        bindDoctorUpdate() {
            sessionStorage.setItem('userNos', JSON.stringify(this.resultBind))
            this.$router.push({
                path: '/bindDoctorUpdate',

            })
        },
        bindDoctor() {
            sessionStorage.setItem('userNos', JSON.stringify(this.userNos))
            this.$router.push('/bindDoctor')
        },
        copy(value) {
            const input = document.createElement("input");
            input.value = value;
            document.body.appendChild(input);
            input.select();
            document.execCommand("Copy");
            document.body.removeChild(input);
            this.$toast("复制成功");
        }
    }
}
</script>
<style lang="scss" scoped>
.search-box {
    display: flex;
    min-height: 44px;
    width: 100%;
    border-radius: 8px;
    padding: 16px;
    box-sizing: border-box;
    background: #fff;

    &.search-no-padding {
        padding-bottom: 0;
        border-radius: 8px 8px 0 0;
        margin-bottom: -2px;
    }

    :deep(.van-search) {
        width: 100%;
        padding: 0;

        .van-search__action {
            padding: 0;
        }

        .van-field__left-icon {
            display: none;
        }

        .van-search__content {
            padding: 0 15px;
            background-color: #ffffff;
            border-radius: 8px 0 0 8px;
            opacity: 1;
            border: 1px solid #E1E8EF;
            border-right-color: transparent;
        }
    }

    .search-button {
        width: 72px;
        height: 44px;
        line-height: 44px;
        background: #0082EF;
        border-radius: 0px 8px 8px 0px;
        opacity: 1;
        color: #ffffff;
        text-align: center;
    }
}

    :deep(.title-box) {
    .van-cell__title {
        display: flex;
        align-items: center;
    }

    .mobile-box {
        flex: 1;
        font-size: 14px;
        color: #333333;
        display: flex;
        align-items: center;
        padding-right: 15vw;
        justify-content: flex-end;
    }
}

.user {
    margin-top: 10px;
    font-size: 14px;

    .content {
        background: #fff;
        padding: 10px 16px;
        height: calc(100vh - #{'250px'});
        border-radius: 4px;
        overflow-y: auto;

        .van-cell {
            padding-left: 0;
            padding-right: 0;
            width: auto;
            font-size: 16px;
            background-color: transparent;
        }

        .van-cell::after {
            left: 0;
            right: 0;
        }

        .title {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #333;

            img {
                width: 38px;
                height: 38px;
                border-radius: 50%;
                margin-right: 10px;
            }
            .title_user_name {
                display: flex;
                flex-direction: column;
            }
        }
        .copyClass {
            color: #0082EF;
        }

        :deep() .van-checkbox__icon {
            font-size: 18px;

            .van-icon {
                width: 18px;
                height: 18px;
                line-height: 18px;
            }
        }
    }

    .pagination {
        padding: 20px 0;
    }

    .footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        height: 84px;
        background: #fff;
        display: flex;
        align-items: center;
        padding: 0 30px;

        button {
            border-radius: 8px;
        }
    }

    // 已绑定
    .bind_header,
    .bind_list {
        width: 100%;
        height: 44px;
        background: #F6FBFF;
        display: flex;
        font-weight: 400;
        color: #333333;
        font-size: 14px;
        padding: 0 12px;
        box-sizing: border-box;

        // justify-content: space-between;
        .bind_user_name {
            width: 45%;
            height: 44px;
            display: flex;
            align-items: center;
            cursor: pointer;

            .avatar {
                display: flex;
                align-items: center;
            }

            img {
                width: 28px;
                height: 28px;
                border-radius: 50%;
                margin-right: 8px;
            }
        }

        .bind_doctor_name {
            display: flex;
            height: 44px;
            align-items: center;
            width: 35%;
            cursor: pointer;
        }

        .bind_status {
            display: flex;
            height: 44px;
            align-items: center;
            width: 20%;
            cursor: pointer;
        }
    }

    .isOnline {
        display: flex;
        justify-content: flex-end;
        padding: 10px;

        :deep() .van-radio__icon {
            font-size: 18px;

            .van-icon {
                width: 18px;
                height: 18px;
                line-height: 18px;
            }
        }
    }

    .bind_list {
        background: transparent;
        display: block;
        height: auto;

        .bind_item {
            border-bottom: 1px solid #F6FBFF;
            display: flex;

            .bind_status {
                color: #0FBC54;
            }

            .doctorStatus1 {
                color: #E81C1C;
            }

            .isOnline0 {
                color: #999999;
            }
        }
    }
}
</style>
<style>
.van-popover__action {
    font-size: 14px !important;
    height: 50px !important;
}
</style>